'use client'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import './styles.css'

import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { memo } from 'react'

const CARD_BOX_SX = {
  borderRadius: 5,
  border: '2px solid var(--primary-color)',
  overflow: 'hidden',
  height: '100%',
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'start',
  flexDirection: 'column',
  minHeight: '200px',
  px: 4,
}

const AVATAR_ROW_SX = {
  display: 'flex',
  justifyContent: 'start',
  width: '100%',
}

const AVATAR_INFO_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  ml: 2,
}

interface Card {
    title?: string
    subtitle?: string
    description?: string
}

interface SwiperV2Props {
    cards?: Card[]
}

const Index = ({ cards = [] }: SwiperV2Props) => {
    function stringAvatar(name: string) {
        const parts = name.split(' ')
        if (parts.length >= 2) {
            return {
                children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
            }
        }
        return {
            children: name[0]?.toUpperCase() || '?',
        }
    }

    return (
        <Swiper
            modules={[Navigation]}
            navigation={true}
            loop={true}
            spaceBetween={10}
            className='mySwiper'
            breakpoints={{
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            }}
        >
            {cards.map((item, index) => (
                <SwiperSlide key={'cards-reviews' + index}>
                    <Box
                        sx={CARD_BOX_SX}
                    >
                        <Box sx={AVATAR_ROW_SX}>
                            <Avatar {...stringAvatar(item.title || '')} sx={{ bgcolor: 'primary.main' }} />
                            <Box sx={AVATAR_INFO_SX}>
                                <Typography variant='body2' sx={{ textTransform: 'uppercase', fontSize: '1.3rem' }}>{item.title}</Typography>
                                <Typography variant='body1' sx={{ color: 'text.primary' }}>{item.subtitle}</Typography>
                            </Box>
                        </Box>

                        <Typography variant='body2'>{item.description}</Typography>
                    </Box>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default memo(Index)


